
import React from 'react';
import { ArrowRight, FileSearchIcon } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const CallToAction = () => {
  const navigate = useNavigate();
  
  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-r from-yellow-500 to-yellow-300 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10">
        <div className="absolute top-10 left-10 w-40 h-40 rounded-full border-4 border-white"></div>
        <div className="absolute bottom-10 right-10 w-60 h-60 rounded-full border-4 border-white"></div>
        <div className="absolute top-1/2 left-1/4 w-20 h-20 rounded-full border-2 border-white"></div>
        <div className="absolute bottom-1/4 right-1/3 w-24 h-24 rounded-full border-2 border-white"></div>
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-montserrat font-bold text-darkgray mb-4 sm:mb-6">
            Redo att effektivisera ditt arbete med offentliga upphandlingar?
          </h2>
          <p className="text-darkgray/90 text-base sm:text-lg mb-8 sm:mb-10 max-w-2xl mx-auto px-2 font-opensans">
            Anslut dig till hundratals företag som redan förbättrat sina anbudsprocesser med Snabbaupphandlingar. Kom igång idag med en gratis 14-dagars provperiod.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4">
            <Button size="lg" className="w-full sm:w-auto bg-white text-darkgray hover:bg-white/90 hover:shadow-lg font-montserrat font-bold" onClick={() => handleNavigation('/auth')}>
              <FileSearchIcon className="mr-2 h-5 w-5" />
              Starta din gratis provperiod
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto mt-3 sm:mt-0 border-darkgray text-darkgray hover:bg-darkgray hover:text-white flex items-center font-montserrat font-bold" onClick={() => handleNavigation('/auth')}>
              Boka en demonstration <ArrowRight className="ml-1 h-3.5 w-3.5 sm:h-4 sm:w-4" />
            </Button>
          </div>
          
          <p className="mt-4 sm:mt-6 text-darkgray/80 text-xs sm:text-sm font-opensans">
            Ingen kreditkortsinformation krävs. Avsluta när som helst.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
